import React from "react";
import { IoMdClose } from "react-icons/io";
import { BsListCheck } from "react-icons/bs";
import useReactRouter from "use-react-router";
import {
  MdOutlineArrowDropDown,
  MdOutlineArrowDropUp,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";
import { faDollarSign, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Modal, Table } from "react-bootstrap";
function OrderPrint() {
    const {history}=useReactRouter()
    const _gotoOrderList=()=>{
        history.push(`/orderlist`)
    }
    const _gotoOrderMove=()=>{
    history.push(`/ordermove`)
    }
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #D1D1D1",
          paddingBottom: 20,
        }}
       
      >
        <div style={{ color: "#422F90" }}
         onClick={()=>_gotoOrderList()}
        >
          <IoMdClose />
        </div>
        <div>
          <BsListCheck />
        </div>
      </div>
      <div style={{ fontSize: 24, fontWeight: "bold", marginTop: 26 }}>
        1 item slected
      </div>
      <div>
        11/02/2022
        <span style={{ marginLeft: 19 }}>
          <MdOutlineKeyboardArrowDown />
        </span>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 80,
        }}
      >
        <Table style={{ background: "#FFFF" }}>
          <thead>
            <tr>
              <th style={{ borderTop: "none" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>#</div>

                  <div style={{ marginLeft: 8 }}>
                    <div style={{ padding: 0, marginBottom: -15 }}>
                      <MdOutlineArrowDropUp />
                    </div>
                    <div style={{ padding: 0, marginTop: -15 }}>
                      {" "}
                      <MdOutlineArrowDropDown />
                    </div>
                  </div>
                </div>
              </th>
              <th style={{ borderTop: "none" }}>ຊື່ລູກຄ້າ</th>
              <th style={{ borderTop: "none" }}>ຈຳນວນ</th>
              <th style={{ borderTop: "none" }}>ລາຄາ</th>
              <th style={{ borderTop: "none" }}>ການຈັດການ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>001</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#422F90",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#FFFF",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>001</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#422F90",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#FFFF",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>002</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#422F90",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#FFF",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>003</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#EAE8F3",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#422F90",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>004</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#EAE8F3",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#422F90",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>005</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#EAE8F3",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#422F90",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>006</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#EAE8F3",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#422F90",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>006</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#EAE8F3",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#422F90",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>007</td>
              <td>ສຸກສະຫວັນ</td>
              <td>99</td>
              <td>50,000</td>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#EAE8F3",
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#422F90",
                      }}
                      icon={faDollarSign}
                    />
                  </div>

                  <div
                    style={{
                      background: "#FFFF",
                      marginLeft: 20,
                      width: 30,
                      height: 30,
                      display: "flex",
                      borderRadius: 6,
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #D1D5DB",
                    }}
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#5C5C5C",
                      }}
                      icon={faPrint}
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      <div
        className="d-grid gap-2"
        style={{ position: "fixed", bottom: 20, width: "80%" }}
      >
          
        <Button style={{ background: "#422F90" }}
        onClick={()=>_gotoOrderMove()}
        >Move</Button>
      </div>

     
    </div>
  );
}

export default OrderPrint;
